import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function RouteUpdater() {
  const location = useLocation();

  useEffect(() => {
    sessionStorage.setItem('CURRENT_ROUTE', location.pathname);
  }, [location]);

  return null; // Este componente não renderiza nada
}

export default RouteUpdater;
